import * as z from "zod";

export const deleteWorkOrderPriorityFilter = {
  name: "deleteWorkOrderPriorityFilter" as const,
  input: z.object({ id: z.string() }),
  output: z.object({ success: z.boolean() }),
};
